const SENSITIVE_KEYS = new Set([
  'email',
  'emailaddress',
  'name',
  'firstname',
  'lastname',
  'fullname',
  'phone',
  'phonenumber',
  'contactid',
  'results',
]);

/** Drop name, email, phone, and anything else that should not leave the browser. */
export function stripSensitive(
  properties?: Record<string, any>,
): Record<string, unknown> | undefined {
  if (!properties) {
    return undefined;
  }

  const safe: Record<string, unknown> = {};
  Object.entries(properties).forEach(([key, value]) => {
    const normalized = key.toLowerCase().replace(/[^a-z0-9]/g, '');
    if (SENSITIVE_KEYS.has(normalized)) {
      return;
    }
    if (typeof value === 'string' && value.includes('@')) {
      return;
    }
    if (value == null) {
      return;
    }
    safe[key] = value;
  });
  return safe;
}

export function sanitizeEventName(event: string): string {
  const cleaned = event
    .replace(/[^A-Za-z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .slice(0, 120);
  return cleaned || 'event';
}
